<template>
    <div v-bind:class="`bg-${color}-500`" class="overflow-hidden relative text-white rounded">
        <span class="bg-purple-500 bg-blue-500 bg-green-500 bg-gray-500 bg-yellow-500"> </span>
        <slot></slot>
        <div v-if="icon" class="absolute -m-2  right-0 bottom-0">
            <i v-bind:class="icon" class="fas align-middle text-white opacity-50 fa-4x"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: 'gray'
        },
        icon: {
            type: String,
            default: null
        }
    }
}
</script>
